import { useCallback, useContext, useEffect, useState } from 'react';

import {
  Accessories,
  ComplementaryDocuments,
  GeneralData,
  Inspection,
  Trackers,
} from '..';
import { Card } from '@hdi-seguros/web-components.card';
import { Tabs } from '@hdi-seguros/web-components.tabs';

import {
  Form,
  RowSize,
} from '../../../../../../../../../../../shared/components';
import { StepTwoFormContext } from '../../../../../StepTwo/contexts/StepTwoForm';
import { StepFourFormContext } from '../../../../contexts/StepFourForm';
import { DECISION_TYPE } from '../../../../../../../../../../../shared/interfaces';

import './index.css';
import { WizardDataFormContext } from '../../../../../../Wizard/contexts/WizardDataForm';

export const TabSection = () => {
  const [quotationTabs, setQuotationTabs] = useState<Array<any>>([]);
  const [activeTab, setActiveTab] = useState(quotationTabs[0]?.key);

  const { stepTwoForm, coverageSelectedByVehicle } = useContext(
    WizardDataFormContext
  );
  const { tabs, generateTitleForTabs, accessoryTable,  } =
    useContext(StepTwoFormContext);
  const { tabsSectionForm, fileSelect, setFileSelect } = useContext(StepFourFormContext);

 const needInspection = useCallback(
    (componentId: string): boolean => {
      const flag = coverageSelectedByVehicle.find(
        (el) => String(el.componentId) === String(componentId)
      )?.coverageSelected.requiereInspeccion;
      const normalized = String(flag ?? '').toUpperCase();
      return normalized === DECISION_TYPE.YES;
    },
    [coverageSelectedByVehicle]
  );

  const vehicleHasAccessories = useCallback(
    (componentId: string) => !!accessoryTable[componentId]?.length,
    [accessoryTable]
  );

  const needTracker = useCallback(
    (componentId: string): boolean =>
      coverageSelectedByVehicle.find((el) => el.componentId === componentId)
        ?.coverageSelected.requiereRastreador === DECISION_TYPE.YES,
    [coverageSelectedByVehicle]
  );

  const renderSection = useCallback(
    (key: number) => (
      <Card>
        <GeneralData tabKey={key} />

        {vehicleHasAccessories(String(key)) ? (
          <Accessories tabKey={key} />
        ) : (
          <></>
        )}

        {needInspection(String(key)) ? <Inspection tabKey={key} /> : <></>}

        {needTracker(String(key)) ? <Trackers tabKey={key} /> : <></>}

        <ComplementaryDocuments fileSelect={fileSelect} setFileSelect={setFileSelect} />
      </Card>
    ),
    [vehicleHasAccessories, needInspection, needTracker,fileSelect, setFileSelect]
  );

  const handlePressTab = (activeTab: string) => setActiveTab(activeTab);

  const setLabelHeader = useCallback(
    (key: number) => {
      if (tabs.length > 1) {
        const brand = stepTwoForm?.getFieldValue(`brand-tab-${key}`);
        const model = stepTwoForm?.getFieldValue(`model-tab-${key}`);
        const year = stepTwoForm?.getFieldValue(`vehicleYear-tab-${key}`);

        return generateTitleForTabs(year, brand, model);
      }

      return `Automóvil ${key}`;
    },
    [tabs, stepTwoForm, generateTitleForTabs]
  );

  const createTabs = useCallback(() => {
    const newTabs = tabs?.map(({ key }) => ({
      children: renderSection(key),
      forceRender: true,
      closable: false,
      key,
      label: setLabelHeader(key),
    }));

    setQuotationTabs(newTabs);
  }, [tabs, setQuotationTabs, setLabelHeader, renderSection]);

  useEffect(() => {
    createTabs();
  }, [createTabs]);

  return (
    <div className='tab-section-car'>
      <RowSize className='p-15 w-auto'>
        <Form
          formProps={{
            name: 'vehicle-info-section-form',
            form: tabsSectionForm,
          }}
        >
          <Tabs
            handlePressTab={handlePressTab}
            activeKey={activeTab}
            items={quotationTabs}
          />
        </Form>
      </RowSize>
    </div>
  );
};
